export * from '../src/composites/wui-banner/index.js';
//# sourceMappingURL=wui-banner.js.map